import React from "react"

export const CheckedState: React.FC = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9" cy="9" r="8" fill="white" stroke="#1693BE" />
      <circle cx="9" cy="9" r="5" fill="#1693BE" stroke="#1693BE" />
    </svg>
  )
}
